<template>
  <div class="container">
    <m-row class="top-row noselect" @click="toggleCollapse">
      <!-- Left Section: Icon and Title -->
      <m-col cols="11" class="d-flex align-items-center">
        <i
          style="font-size: 42px;"
          :class="[
            'mdi',
            icon,
            'nav-icon',
          ]"
        ></i>
        
        <span class="ml-2 fixed-font">{{ title }}</span>
      </m-col>

      <m-col cols="1" class="d-flex justify-content-end">
        <a href="#" class="mt-2">
          <span v-if="show_form" class="svg-icon svg-icon-md svg-icon-primary">
            <inline-svg src="/assets/svg/angle-up-solid.svg" style="fill: #919191"></inline-svg>
          </span>
          <span v-else class="svg-icon svg-icon-md svg-icon-primary">
            <inline-svg src="/assets/svg/angle-down-solid.svg"></inline-svg>
          </span>
        </a>
      </m-col>
    </m-row>

    <div v-if="show_form" class="mt-4">
      <slot></slot>
    </div>

    <hr/>
  </div>
</template>

<script>
export default {
  name: 'CollapsibleListItem',
  props: {
    title: { type: String, required: true },
    icon: { type: String, default: 'mdi-email-outline' }, // Default icon
    expanded: { type: Boolean, default: false }
  },
  data() {
    return {
      show_form: this.expanded
    };
  },
  methods: {
    toggleCollapse() {
      this.show_form = !this.show_form;
    }
  },
  watch: {
    expanded(newVal) {
      this.show_form = newVal;
    }
  }
};
</script>

<style scoped>
.container {
  margin-bottom: 15px;
}

.top-row {
  cursor: pointer;
}

.fixed-font {
  font-weight: 600;
  font-size: 16px;
}
</style>
